import { render, staticRenderFns } from "./Glucose.vue?vue&type=template&id=25ca64b8&"
import script from "./Glucose.vue?vue&type=script&lang=ts&"
export * from "./Glucose.vue?vue&type=script&lang=ts&"
import style0 from "./Glucose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports